<template>
  <nav aria-label="menu">
    <ul class="n-menu">
      <SMenuItem
        v-bind="item"
        v-for="(item, index) in items"
        :key="index"
        :children="item.children || []"
        :id="item.id"
        @dropdownClicked="emit('selectedMenueItemVal', item)"
        @itemClicked="handleItemClick(item)"
      >
        <SMenuItem
          v-bind="subItem"
          v-for="subItem in item.children || []"
          :key="subItem.label"
          :style="'--menu-color: #444;'"
          :css-flags="['dark', 'bg-hover', 'vertical', 'with-padding']"
          :id="subItem.id"
          @itemClicked="handleItemClick(subItem)"
        />
      </SMenuItem>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
interface Props {
  items: {
    label: string;
    link: string;
    id: string;
    children?: {
      label: string;
      link: string;
      id: string;
    }[];
  }[];
}
const emit = defineEmits(['selectedMenueItemVal']);

withDefaults(defineProps<Props>(), {
  items: () => []
});

const SMenuItem = defineAsyncComponent(() => import('@/components/Header/SMenuItem.vue'));

function handleItemClick(subItem) {
  emit('selectedMenueItemVal', subItem);
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/css_BASE/helpers/mixins/_bp.scss' as *;

.n-menu {
  display: none;
  column-gap: 26px;
  @include bp(lg) {
    display: flex;
    justify-content: flex-end;
    height: 100%;
  }
}
</style>
